var _defs, _style;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportAProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182.27,
    height: 184.29,
    viewBox: "0 0 182.27 184.29",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2488",
    x1: -21.157,
    x2: 181.25,
    y1: 69.028,
    y2: 69.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.87811 0 0 1.0025 20.79 25.577)",
    d: "m80.045-19.903c4.0469 0 103.19 171.73 101.17 175.23-2.0234 3.5047-200.32 3.5047-202.34 0-2.0234-3.5047 97.124-175.23 101.17-175.23z",
    style: {
      fill: "#f67535",
      strokeMiterlimit: 40,
      strokeWidth: 0.53292,
      stroke: "url(#linearGradient2488)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.7464 0 0 .8521 31.117 40.697)",
    d: "m80.045-19.903c4.0469 0 103.19 171.73 101.17 175.23-2.0234 3.5047-200.32 3.5047-202.34 0-2.0234-3.5047 97.124-175.23 101.17-175.23z",
    style: {
      fill: "#fc0",
      strokeMiterlimit: 40,
      strokeWidth: 0.62696,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.666,
    y: 59.422,
    width: 10.486,
    height: 79.229,
    rx: 10,
    ry: 4.5431,
    style: {
      fillOpacity: 0.94118,
      fill: "#f77535",
      strokeMiterlimit: 40,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.084,
    y: 147.97,
    width: 10.486,
    height: 14.37,
    rx: 10,
    ry: 4.5431,
    style: {
      fillOpacity: 0.94118,
      fill: "#f77535",
      strokeMiterlimit: 40,
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAProblem);
export default __webpack_public_path__ + "static/media/report_a_problem.f28baf0639b506c39ea289eaaa6cb91e.svg";
export { ForwardRef as ReactComponent };